import { Node_Type } from "./../../ricos-types/index.js";
import Caption from "../../_shared/figure/viewer-caption.js";
import Image from "./viewer-image.js";
const nodeViewRenderers = {
  [Node_Type.IMAGE]: Image,
  [Node_Type.CAPTION]: Caption
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers.js.map
